import React, { useEffect, useState } from 'react';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { TiPlus } from 'react-icons/ti';
import { FormattedMessage } from 'react-intl';
import { Link, Outlet } from 'react-router-dom';

import Loading from '../../../components/general/Loading';

import { DeleteDialog } from '../../../components/bootstrap/DeleteDialog';
import { SubTemplate } from '../../../components/general/SubTemplate';
import {
  deleteActionNotification,
  getActionNotificationsMetaData,
} from '../../../rest/templates';
import { handleError, isBusinessError } from '../../../utils/handleError';
import {Row} from "react-bootstrap";
import Col from "react-bootstrap/Col";

export function ListActionNotifications() {
  const [actionNotificationsMetaData, setActionNotificationsMetaData] =
    useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);
  const [toDelete, setToDelete] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const fetchData = async () => {
    try {
      const { data: metaData } = await getActionNotificationsMetaData();

      setActionNotificationsMetaData(metaData);
      setLoading(false);
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteNotification = async (code) => {
    try {
      const { data: deletedActionNotification } =
        await deleteActionNotification(code);

      setActionNotificationsMetaData(
        actionNotificationsMetaData.filter(
          (p) => p.code !== deletedActionNotification.code
        )
      );
      setLoading(false);
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };

  const handleOnClickDelete = (actionNotification) => {
    setToDelete(actionNotification);
    handleShow();
  };

  const handleConfirmDelete = () => {
    deleteNotification(encodeURIComponent(toDelete.code));
    handleClose();
  };

  if (loading) {
    return <Loading />;
  }

  if (error && !isBusinessError(error)) {
    return handleError(error);
  }

  return (
      <SubTemplate hasBackButton titleId={'template.manage'}>
        <div className={'container'}>
          <div className={'row'}>
            <div className='col-md-2'>
              <div className='mb-4'>
                <Link to={`/notificacoes/adicionar`} className={'btn btn-outline-primary mb-3'}>
                  <TiPlus className='mb-1 me-2' aria-hidden='true'/>
                  <FormattedMessage id='template.add' />
                </Link>
              </div>
            </div>
            <div className={'col-md-8'}>
              <ul className='results'>
                {actionNotificationsMetaData.map((actionNotification) => (
                  <li key={actionNotification.code}>
                    <Row className='py-3'>
                      <Col md="8 d-flex align-items-center">{actionNotification.description}</Col>

                      <Col md="4" className='d-flex justify-content-end'>
                        {!actionNotification.systemOperational && (
                          <span>
                            <button
                              onClick={() => handleOnClickDelete(actionNotification)}
                              className='btn btn-link me-3'>
                              <FaTrashAlt />
                            </button>
                          </span>
                        )}
                        <Link
                            className="btn btn-link"
                          to={`/notificacoes/${encodeURIComponent(
                            actionNotification.code
                          )}/editar`}>
                          <FaEdit  />
                        </Link>
                      </Col>
                    </Row>
                  </li>
                ))}
                <DeleteDialog
                  show={show}
                  handleClose={handleClose}
                  handleConfirmDelete={handleConfirmDelete}
                />
              </ul>
            </div>
          </div>
        </div>
      </SubTemplate>
  );
}
